import { render } from "./Afff.vue?vue&type=template&id=c0053452&scoped=true"
import script from "./Afff.vue?vue&type=script&lang=js"
export * from "./Afff.vue?vue&type=script&lang=js"

import "./Afff.vue?vue&type=style&index=0&id=c0053452&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c0053452"

export default script